import {
  Component,
  EventEmitter,
  OnInit,
  ViewContainerRef,
} from '@angular/core';
import { FormGroup } from '@angular/forms';

import { Field } from '../../models/field.interface';
import { TypeCesEnum } from 'src/app/domain/registration/enums/type-ces.enum';
import { IFieldConfig } from 'src/app/domain/IFieldConfig';
import { KeyboardService } from '../../../keyboard/keyboard.service';

@Component({
  selector: 'form-slide-toggle',
  styleUrls: ['form-slide-toggle.component.sass'],
  template: `
    <div class="dynamic-field form-input" [formGroup]="group">
      <form *ngIf="!config.labelLeft" [formGroup]="group">
        <mat-slide-toggle
          [formControlName]="config.name"
          (click)="onClick.emit($event)"
          [disabled]="!!config.disabled"
          >{{ config.label }}</mat-slide-toggle
        >
      </form>

      <div *ngIf="config.labelLeft" fxFlex fxLayout="row" fxLayoutGap="8">
        <div fxFlex class="text-left">{{ config.label }}</div>
        <div fxFlex="initial">
          <form [formGroup]="group" fxLayout="row">
            <mat-slide-toggle
              [formControlName]="config.name"
              (click)="onClick.emit($event)"
              [disabled]="!!config.disabled"
            ></mat-slide-toggle>
          </form>
        </div>
      </div>
    </div>
  `,
})
export class FormSlideToggleComponent implements Field, OnInit {
  config: IFieldConfig;
  group: FormGroup;
  typeCes?: TypeCesEnum | undefined;
  onClick: EventEmitter<any> = new EventEmitter<any>();

  constructor(public keyboardService: KeyboardService) {}

  ngOnInit(): void {

  }

  get typeCesEnum() {
    return TypeCesEnum;
  }
}
